import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Message } from 'primereact/message';
import { DynamicReportComponent } from '../../components/reports';
import axiosInstance from '../../config/axios.config';

const ReportGenerator = () => {
    const { reportType, serviceId } = useParams();
    const location = useLocation();
    const [serviceDetails, setServiceDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchServiceDetails();
    }, [serviceId]);

    const fetchServiceDetails = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`/user/report-services/${serviceId}`);

            if (response.data.success) {
                setServiceDetails(response.data.data);
            } else {
                setError('Failed to fetch service details');
            }
        } catch (error) {
            console.error('Error fetching service details:', error);
            setError('Failed to fetch service details');
        } finally {
            setLoading(false);
        }
    };

    // Map URL report type to display name
    const getReportTypeName = () => {
        const typeMap = {
            'equifax': 'Equifax',
            'equifax-gridline': 'Equifax',
            'bank-statement': 'Bank Statement Analysis',
            'bank-statement-analysis': 'Bank Statement Analysis',
            'bank': 'Bank Statement Analysis',
            'pan': 'PAN Details',
            'pan-details': 'PAN Details',
            'driving-licence-detailed': 'Driving Licence',
            'driving-licence': 'Driving Licence',
            'dl-verification': 'Driving Licence'
        };
        return typeMap[reportType] || reportType;
    };

    if (loading) {
        return (
            <div className="surface-ground py-5">
                <Card className="text-center">
                    <ProgressSpinner />
                    <p className="text-xl mt-3">Loading service details...</p>
                </Card>
            </div>
        );
    }

    if (error) {
        return (
            <div className="surface-ground py-5">
                <Card>
                    <Message severity="error" text={error} className="w-full" />
                </Card>
            </div>
        );
    }

    return (
        <div className="surface-ground py-5">
            <div className="grid">
                <div className="col-12">
                    <DynamicReportComponent
                        reportType={getReportTypeName()}
                        serviceId={serviceId}
                        serviceDetails={serviceDetails}
                    />
                </div>
            </div>
        </div>
    );
};

export default ReportGenerator;